/* ==========================================================================
   Oz BBQ AAA: cart + search behaviour. Vanilla, no dependencies.
   Every feature upgrades a working no-JS form or link.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__cxInit) return;
  window.__cxInit = true;

  var doc = document;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + v;
  };
  var parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
  doc.documentElement.classList.add('cx-js');

  /* ---- Rails: arrow paging ------------------------------------------- */
  function initRails(scope) {
    Array.prototype.forEach.call((scope || doc).querySelectorAll('[data-cx-track]'), function (track) {
      var wrap = track.parentNode;
      var prev = wrap.querySelector('[data-cx-prev]');
      var next = wrap.querySelector('[data-cx-next]');
      if (!prev || !next || track.__cxRail) return;
      track.__cxRail = true;
      var sync = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        wrap.classList.toggle('is-static', max <= 0);
        track.classList.toggle('is-end', track.scrollLeft >= max);
        // Phones: a thin progress track says the row scrolls and how far along it is.
        var bar = wrap.querySelector('[data-cx-prog] > span');
        if (bar && track.scrollWidth > 0) {
          var r = Math.min(1, track.clientWidth / track.scrollWidth);
          var x = track.scrollLeft / track.scrollWidth * 100;
          bar.style.transform = 'translateX(' + x.toFixed(2) + '%) scaleX(' + r.toFixed(3) + ')';
        }
      };
      var page = function (dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' }); };
      prev.addEventListener('click', function () { page(-1); });
      next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ==================================================================== */
  /* CART                                                                   */
  /* ==================================================================== */
  function initCart() {
    var cart = doc.querySelector('[data-cx-cart]');
    if (!cart) return;
    var sectionId = cart.getAttribute('data-section');
    var recsHtml = null;     // cached recommendation cards
    var pending = null;

    function status(msg) {
      var s = cart.querySelector('[data-cx-status]');
      if (s) s.textContent = msg;
    }

    function swap(html) {
      var fresh = parse(html).querySelector('[data-cx-cart]');
      if (!fresh) { window.location.reload(); return; }
      var wasEmpty = cart.classList.contains('is-empty');
      if (fresh.classList.contains('is-empty') !== wasEmpty) { window.location.reload(); return; }
      var focusId = doc.activeElement && doc.activeElement.id;
      var focusStep = doc.activeElement && doc.activeElement.getAttribute('data-cx-step');
      var focusLine = doc.activeElement && doc.activeElement.closest('[data-cx-line]');
      focusLine = focusLine && focusLine.getAttribute('data-key');
      // keep the rail (and any swapped-in recommendations) as is
      var oldRecs = cart.querySelector('[data-cx-recs]');
      var newRecs = fresh.querySelector('[data-cx-recs]');
      if (oldRecs && newRecs) newRecs.parentNode.replaceChild(oldRecs, newRecs);
      cart.innerHTML = fresh.innerHTML;
      cart.className = fresh.className;
      bindBar();
      bindEta();
      markWallets();
      if (focusLine) {
        var line = cart.querySelector('[data-key="' + focusLine + '"]');
        var el = line && (focusStep ? line.querySelector('[data-cx-step="' + focusStep + '"]') : null);
        if (el && !el.disabled) el.focus();
        else if (line) { var inp = line.querySelector('[data-cx-input]'); if (inp) inp.focus(); }
      } else if (focusId) {
        var f = doc.getElementById(focusId);
        if (f) f.focus();
      }
      doc.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    // Count the wallets Shopify was configured with (closed shadow root, so
    // the light-DOM config attribute is all we can read).
    function markWallets() {
      var box = cart.querySelector('.cx-sum__express-btns');
      var el = box && box.querySelector('[wallet-configs]');
      if (!el) return;
      var names = [];
      try { names = JSON.parse(el.getAttribute('wallet-configs')).map(function (w) { return w.name; }); } catch (e) { return; }
      box.setAttribute('data-wallets', String(names.length));
      var pp = names.indexOf('paypal');
      if (pp < 0) return;
      // PayPal's iframe paints a few seconds after the others. Until it does,
      // its slot shows a PayPal-yellow plate (not a grey hole); if it never
      // arrives the plate steps aside.
      box.setAttribute('data-pp', String(pp));
      var t0 = Date.now();
      var tick = function () {
        if (!box.isConnected) return;
        if (box.querySelector('.paypal-buttons iframe.component-frame.visible')) { box.classList.add('is-pp-ready'); return; }
        if (Date.now() - t0 > 20000) { box.classList.add('is-pp-dead'); return; }
        setTimeout(tick, 400);
      };
      tick();
    }

    function change(line, qty, lineEl) {
      if (pending) pending.abort && pending.abort();
      var ctrl = window.AbortController ? new AbortController() : null;
      pending = ctrl;
      cart.classList.add('is-busy');
      if (lineEl && qty === 0) lineEl.classList.add('is-leaving');
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: [sectionId], sections_url: window.location.pathname }),
        signal: ctrl ? ctrl.signal : undefined
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          cart.classList.remove('is-busy');
          if (!res.ok) {
            if (lineEl) {
              lineEl.classList.remove('is-leaving');
              var err = lineEl.querySelector('[data-cx-err]');
              if (err) { err.textContent = res.j.description || res.j.message || 'Could not update that quantity.'; err.hidden = false; }
            }
            // re-sync the numbers anyway
            return fetch(window.location.pathname + '?section_id=' + sectionId).then(function (r) { return r.text(); }).then(function (h) {
              var keepErr = lineEl && lineEl.querySelector('[data-cx-err]');
              var msg = keepErr && keepErr.textContent;
              var key = lineEl && lineEl.getAttribute('data-key');
              swap(h);
              if (key && msg) {
                var l = cart.querySelector('[data-key="' + key + '"] [data-cx-err]');
                if (l) { l.textContent = msg; l.hidden = false; }
              }
            });
          }
          var html = res.j.sections && res.j.sections[sectionId];
          status(qty === 0 ? 'Item removed. Cart now has ' + res.j.item_count + ' items.' : 'Cart updated. ' + res.j.item_count + ' items, total ' + money(res.j.total_price) + '.');
          if (html) swap(html); else window.location.reload();
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          cart.classList.remove('is-busy');
          window.location.reload();
        });
    }

    cart.addEventListener('click', function (e) {
      var step = e.target.closest('[data-cx-step]');
      if (step) {
        var lineEl = step.closest('[data-cx-line]');
        var input = lineEl.querySelector('[data-cx-input]');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-cx-step'), 10));
        var max = parseInt(input.getAttribute('max'), 10);
        if (max && next > max) next = max;
        input.value = next;
        change(parseInt(lineEl.getAttribute('data-cx-line'), 10), next, lineEl);
        return;
      }
      var rm = e.target.closest('[data-cx-remove]');
      if (rm) {
        e.preventDefault();
        var le = rm.closest('[data-cx-line]');
        change(parseInt(rm.getAttribute('data-cx-remove'), 10), 0, le);
      }
    });

    cart.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cx-input]');
      if (!input) return;
      var lineEl = input.closest('[data-cx-line]');
      var v = Math.max(0, parseInt(input.value, 10) || 0);
      change(parseInt(input.getAttribute('data-line'), 10), v, lineEl);
    });
    cart.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-cx-input]')) {
        e.preventDefault();
        e.target.blur();
      }
    });

    // Order note: save as you type
    var noteTimer;
    cart.addEventListener('input', function (e) {
      if (!e.target.matches('[data-cx-note]')) return;
      var ta = e.target;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: ta.value })
        }).then(function (r) {
          var s = cart.querySelector('[data-cx-note-saved]');
          if (s && r.ok) { s.textContent = 'Note saved'; setTimeout(function () { s.textContent = ''; }, 2400); }
        }).catch(function () {});
      }, 600);
    });

    // Upsell quick add: add, then re-render the cart
    // One toast for add-to-order feedback, wherever the shopper is on the page.
    var toastTimer;
    function toast(html) {
      var t = cart.querySelector('[data-cx-toast]');
      if (!t) return;
      t.innerHTML = html;
      t.hidden = false;
      window.requestAnimationFrame(function () { t.classList.add('is-on'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        t.classList.remove('is-on');
        setTimeout(function () { t.hidden = true; }, reduce ? 0 : 260);
      }, 5200);
    }
    function setAdded(b) {
      b.classList.add('is-added');
      b.setAttribute('aria-disabled', 'true');
      var l = b.querySelector('.aaa-pc__add-label'); if (l) l.textContent = 'In cart';
    }
    function markAdded(pid) {
      if (!pid) return;
      var sel = '[data-pid="' + pid + '"] .cx-pc__add';
      Array.prototype.forEach.call(cart.querySelectorAll(sel), setAdded);
      if (recsHtml) {
        var tmp = doc.createElement('div'); tmp.innerHTML = recsHtml;
        Array.prototype.forEach.call(tmp.querySelectorAll(sel), setAdded);
        recsHtml = tmp.innerHTML;
      }
    }
    function toTop() {
      var top = cart.querySelector('[data-cx-head]');
      if (top) top.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
    cart.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-cx-add]')) return;
      e.preventDefault();
      var btn = form.querySelector('button');
      var label = form.querySelector('.aaa-pc__add-label');
      if (btn.getAttribute('aria-busy') === 'true') return;
      var item = form.closest('.cx-rail__item');
      // Already on the order: take them to it rather than adding a second.
      if (btn.classList.contains('is-added')) { toTop(); return; }
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-busy');
      if (label) label.textContent = 'Adding';
      var fd = new FormData(form);
      fd.append('sections', sectionId);
      fd.append('sections_url', window.location.pathname);
      var tl = item && item.querySelector('.cx-pc__title a');
      var name = tl ? tl.textContent.trim() : 'That';
      if (item && !item.getAttribute('data-pid')) item.setAttribute('data-pid', 'x' + Date.now());
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          btn.classList.remove('is-busy');
          btn.removeAttribute('aria-busy');
          markAdded(item && item.getAttribute('data-pid'));
          if (j.sections && j.sections[sectionId]) swap(j.sections[sectionId]);
          else { window.location.reload(); return; }
          var tot = cart.querySelector('.cx-sum__total strong');
          var safe = name.replace(/[<>&"]/g, '');
          toast('<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="m3 8.5 3.2 3.2L13 4.8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '<span><strong>' + safe + '</strong> is on the order.' + (tot ? ' New total <b class="aaa-num">' + tot.textContent + '</b>' : '') + '</span>' +
            '<a href="#CxCartForm" data-cx-toast-go>View order</a>');
          status(safe + ' added to your order.');
        })
        .catch(function () { form.removeAttribute('data-cx-add'); form.submit(); });
    });
    cart.addEventListener('click', function (e) {
      var go = e.target.closest('[data-cx-toast-go]');
      if (!go) return;
      e.preventDefault();
      toTop();
      var t = cart.querySelector('[data-cx-toast]'); if (t) { t.classList.remove('is-on'); t.hidden = true; }
    });

    // Recommendations: complementary first, then related, for the priciest item
    function loadRecs() {
      var recs = cart.querySelector('[data-cx-recs]');
      if (!recs) return;
      var pid = recs.getAttribute('data-product-id');
      var url = recs.getAttribute('data-url');
      var exclude = recs.getAttribute('data-exclude') || '';
      var anchorPrice = parseInt(recs.getAttribute('data-anchor-price'), 10) || 0;
      var anchorTitle = recs.getAttribute('data-anchor-title') || '';
      // What already ships in the box (the cooker's own "Included" spec row).
      // An add-on whose name ends the same way ("... Flexible Cooking Rack")
      // is something the buyer is already getting, so it isn't offered.
      var boxKeys = (recs.getAttribute('data-inbox') || '').split(/\s*(?:\||,|\/|·)\s*/).map(function (t) {
        var w = t.toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').trim().split(/\s+/).filter(Boolean);
        if (w.length < 2) return '';
        var last = w[w.length - 1].replace(/ies$/, 'y').replace(/(ch|sh|x|ss)es$/, '$1').replace(/([^s])s$/, '$1');
        return w[w.length - 2] + ' ' + last;
      }).filter(function (k) { return k.length > 4; });
      var inBox = function (li) {
        var a = li.querySelector('.cx-pc__title a');
        var t = ' ' + ((a && (a.getAttribute('title') || a.textContent)) || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ') + ' ';
        return boxKeys.some(function (k) { return t.indexOf(' ' + k) !== -1; });
      };
      // The server-rendered starter rail obeys the same rule.
      Array.prototype.forEach.call(recs.querySelectorAll('[data-cx-track] > .cx-rail__item'), function (li) { if (inBox(li)) li.remove(); });
      if (!pid || !url) return;
      var get = function (intent) {
        return fetch(url + '?section_id=aaa-cart-recs&limit=10&intent=' + intent + '&product_id=' + pid)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h) {
            var box = parse(h).querySelector('[data-cx-recs-result]');
            if (!box) return [];
            var cap = anchorPrice * 0.4;
            return Array.prototype.filter.call(box.querySelectorAll('.cx-rail__item'), function (li) {
              if (exclude.indexOf(',' + li.getAttribute('data-pid') + ',') !== -1) return false;
              if (inBox(li)) return false;
              // never pitch a second cooker against the one in the cart
              var pr = parseInt(li.getAttribute('data-price'), 10) || 0;
              return !(anchorPrice > 30000 && pr > cap);
            });
          })
          .catch(function () { return []; });
      };
      get('complementary').then(function (items) {
        if (items.length >= 4) return { items: items, intent: 'complementary' };
        return get('related').then(function (rel) {
          var seen = {};
          var merged = items.concat(rel).filter(function (li) { var id = li.getAttribute('data-pid'); if (seen[id]) return false; seen[id] = 1; return true; });
          return { items: merged, intent: 'related' };
        });
      }).then(function (res) {
        if (!res.items) return;
        var inStock = res.items.filter(function (li) { return li.getAttribute('data-stock') !== 'order'; });
        // A ready-to-ship order gets ready-to-ship add-ons; order-in gear only tops up a short list.
        res.items = inStock.length >= 4 ? inStock : inStock.concat(res.items.filter(function (li) { return li.getAttribute('data-stock') === 'order'; }));
        if (res.items.length < 4) return;
        var track = recs.querySelector('[data-cx-track]');
        var title = recs.querySelector('#CxRecsTitle');
        var dek = recs.querySelector('.cx-head__dek');
        recsHtml = res.items.map(function (li) { return li.outerHTML; }).join('');
        track.classList.add('is-swapping');
        setTimeout(function () {
          track.innerHTML = recsHtml;
          var shortName = anchorTitle.replace(/\s*[-–(].*$/, '').replace(/^kamado\s+(?=classic|big|joe)/i, '').replace(/\s+(?:bbq\s+)?(?:grill|smoker).*$/i, '').trim();
          if (title) title.textContent = shortName && shortName.length < 28 ? 'Worth adding to your ' + shortName : 'Worth adding to this order';
          if (dek) dek.textContent = boxKeys.length
            ? 'Nothing here doubles up on what already ships in the box.'
            : 'Picked for the gear in your cart. One tap adds it to this order.';
          track.scrollLeft = 0;
          track.__cxRail = false;
          initRails(recs);
          track.classList.remove('is-swapping');
        }, reduce ? 0 : 200);
      });
    }

    // Mobile sticky bar hides only while the real checkout button is on
    // screen, so checkout stays one tap away above and below the summary.
    var io;
    var barSeen = { btn: false, foot: false };
    function bindBar() {
      var bar = cart.querySelector('[data-cx-bar]');
      // Watch the whole summary card: any of it on screen (subtotal, total
      // or its own checkout button) and the bar gets out of the way.
      // The whole card, not just its button: the bar must never sit over the
      // postcode box, and never doubles a checkout button already in view.
      // The figure and the button that matter: Subtotal/Total and Checkout.
      var btn = cart.querySelector('[data-cx-checkout]');
      var tot = cart.querySelector('.cx-sum__total');
      var head = cart.querySelector('[data-cx-head]');
      var foot = doc.querySelector('footer');
      if (io) io.disconnect();
      doc.body.classList.remove('aaa-cart-bar-on');
      if (!bar || !btn || !('IntersectionObserver' in window)) return;
      barSeen = { btn: false, foot: false, head: true };
      // Hidden while the summary's own checkout button or the footer is on
      // screen; otherwise checkout stays one tap away.
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { barSeen[en.target === btn ? 'btn' : en.target === tot ? 'tot' : en.target === head ? 'head' : 'foot'] = en.isIntersecting; });
        // Hidden at the top (the line item and its summary are right there),
        // while the total or checkout button is in view, and over the footer.
        var hide = barSeen.head || barSeen.btn || barSeen.tot || barSeen.foot;
        bar.classList.toggle('is-hidden', hide);
        bar.setAttribute('aria-hidden', hide ? 'true' : 'false');
        Array.prototype.forEach.call(bar.querySelectorAll('button'), function (b) { b.tabIndex = hide ? -1 : 0; });
        doc.body.classList.toggle('aaa-cart-bar-on', !hide && getComputedStyle(bar).display !== 'none');
      });
      io.observe(btn);
      if (tot) io.observe(tot);
      if (head) io.observe(head);
      if (foot) io.observe(foot);
    }

    /* ---- Delivery ETA by postcode ------------------------------------ */
    var PC_KEY = 'aaa-cart-postcode';
    function pcState(pc) {
      if (!/^\d{4}$/.test(pc)) return null;
      var n = parseInt(pc, 10);
      if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return 'ACT';
      if (n >= 800 && n <= 999) return 'NT';
      if ((n >= 1000 && n <= 2599) || (n >= 2619 && n <= 2899) || (n >= 2921 && n <= 2999)) return 'NSW';
      if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
      if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return 'QLD';
      if (n >= 5000 && n <= 5999) return 'SA';
      if (n >= 6000 && n <= 6999) return 'WA';
      if (n >= 7000 && n <= 7999) return 'TAS';
      return null;
    }
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MONS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var STATES = { VIC: 'Victoria', NSW: 'New South Wales', ACT: 'Australian Capital Territory', QLD: 'Queensland', SA: 'South Australia', WA: 'Western Australia', TAS: 'Tasmania', NT: 'Northern Territory' };
    var EXAMPLE_PC = '3000';
    function ymd(s) { var p = String(s).split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
    function fmt(d, withMon) { return DAYS[d.getDay()] + ' ' + d.getDate() + (withMon ? ' ' + MONS[d.getMonth()] : ''); }
    function range(r) {
      if (!r || !r.length) return '';
      var a = ymd(r[0]); var b = ymd(r[r.length - 1]);
      if (a.getTime() === b.getTime()) return fmt(a, true);
      return fmt(a, a.getMonth() !== b.getMonth()) + '&ndash;' + fmt(b, true);
    }
    // Live carrier rates for this exact cart. Shopify computes them async:
    // prepare, then poll until the answer lands. Cached per postcode + cart.
    var shipSeq = 0;
    function quote(pc) {
      var st = pcState(pc);
      var box = cart.querySelector('[data-cx-ship]');
      var cnt = cart.querySelector('[data-cx-count]');
      var key = 'aaa-cart-rate:' + pc + ':' + (box ? box.getAttribute('data-total') : '') + ':' + (cnt ? cnt.textContent : '');
      try { var hit = sessionStorage.getItem(key); if (hit) return Promise.resolve(JSON.parse(hit)); } catch (e) {}
      var q = 'shipping_address%5Bzip%5D=' + pc + '&shipping_address%5Bcountry%5D=Australia&shipping_address%5Bprovince%5D=' + encodeURIComponent(STATES[st]);
      return fetch(root + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          var tries = 0;
          var poll = function () {
            return fetch(root + 'cart/async_shipping_rates.json?' + q, { headers: { Accept: 'application/json' } })
              .then(function (res) { return res.ok ? res.text() : ''; })
              .then(function (t) {
                var j = null; try { j = JSON.parse(t); } catch (e) {}
                if (j && j.shipping_rates) return j.shipping_rates;
                if (++tries > 14) throw new Error('timeout');
                return new Promise(function (ok) { setTimeout(ok, 600); }).then(poll);
              });
          };
          return poll();
        })
        .then(function (rates) {
          var out = rates.map(function (x) { return { n: x.presentment_name || x.name, p: Math.round(parseFloat(x.price) * 100), d: x.delivery_range || [] }; })
            .sort(function (a, b) { return a.p - b.p; });
          try { sessionStorage.setItem(key, JSON.stringify(out)); } catch (e) {}
          return out;
        });
    }
    function shipEls() {
      return {
        box: cart.querySelector('[data-cx-ship]'),
        line: cart.querySelector('[data-cx-ship-line]'),
        to: cart.querySelector('[data-cx-ship-to]'),
        price: cart.querySelector('[data-cx-ship-price]'),
        row: cart.querySelector('[data-cx-ship-row]'),
        total: cart.querySelector('[data-cx-total]'),
        label: cart.querySelector('[data-cx-total-label]'),
        bar: cart.querySelector('[data-cx-bar-total]'),
        barLabel: cart.querySelector('[data-cx-bar-label]'),
        input: cart.querySelector('[data-cx-eta-pc]')
      };
    }
    function setTotal(el, add, pc) {
      var base = parseInt(el.box.getAttribute('data-total'), 10) || 0;
      var t = money(base + (add || 0));
      if (el.total) el.total.textContent = t;
      if (el.bar) el.bar.textContent = t;
      var q = cart.querySelector('[data-cx-bnpl]');
      if (q) q.textContent = money(Math.floor((base + (add || 0)) / 4));
      if (el.label) {
        if (!el.label.hasAttribute('data-base')) el.label.setAttribute('data-base', el.label.innerHTML);
        el.label.innerHTML = add ? 'Total <span class="cx-sum__pre">delivered to ' + pc + '</span>' : el.label.getAttribute('data-base');
      }
      // Items row shows only when a delivery line (or a discount) sits under it.
      var sub = cart.querySelector('[data-cx-sub-row]');
      if (sub && !sub.hasAttribute('data-keep')) sub.hidden = !add;
      var fs = cart.querySelector('[data-cx-fine-ship]');
      if (fs) fs.textContent = add ? 'Delivery to ' + pc + ' included, confirmed at checkout.' : 'Delivery confirmed at checkout.';
      if (el.barLabel) el.barLabel.innerHTML = add ? 'Delivered to ' + pc : el.barLabel.getAttribute('data-base');
    }
    function fallback(el, pc, st) {
      var row = (el.box.getAttribute('data-cx-eta') || '').split(',').filter(function (r) { return r.indexOf(st + ':') === 0; })[0];
      var p = row ? row.split(':') : null;
      el.price.innerHTML = '<span class="cx-sum__muted">At checkout</span>';
      if (el.to) el.to.textContent = 'to ' + pc;
      el.line.innerHTML = (p ? 'Usually ' + p[1] + '&ndash;' + p[2] + ' business days from Bendigo to ' + st + '.' : 'Ships from Bendigo.') + ' The carrier prices it at checkout.';
      setTotal(el, 0);
    }
    function shipRender(pc, mine) {
      var el = shipEls();
      if (!el.box || !el.line) return;
      var st = pcState(pc);
      if (!st) {
        if (mine) {
          el.line.innerHTML = '<span class="cx-eta__err">That doesn&rsquo;t look like an Australian postcode. Four digits, like 3550.</span>';
          if (el.input) el.input.setAttribute('aria-invalid', 'true');
        }
        return;
      }
      if (el.input) el.input.removeAttribute('aria-invalid');
      // The Delivery row only appears once it has the shopper's own price.
      if (el.row) el.row.hidden = !mine;
      if (shipRender.last === pc + mine && el.box.classList.contains('is-loading')) return;
      shipRender.last = pc + mine;
      var seq = ++shipSeq;
      el.box.classList.add('is-loading');
      if (mine) el.price.innerHTML = '<span class="cx-sum__muted">Checking&hellip;</span>';
      el.line.innerHTML = mine ? 'Getting a live quote to ' + pc + ' from the carrier&hellip;' : 'The carrier prices this exact cart live. Pop your postcode in.';
      if (el.to) el.to.textContent = mine ? 'to ' + pc : '';
      quote(pc).then(function (rates) {
        if (seq !== shipSeq) return;
        el.box.classList.remove('is-loading');
        el.box.classList.toggle('is-mine', !!mine);
        if (!rates.length && !mine) {
          el.line.innerHTML = 'The carrier prices this exact cart live. Pop your postcode in.';
          return;
        }
        if (!rates.length) {
          el.price.innerHTML = '<span class="cx-sum__muted">Call us</span>';
          el.line.innerHTML = 'No online quote to ' + pc + ' for this one. <a href="tel:+61342379090">Call 03 4237 9090</a> and we&rsquo;ll price it.';
          setTotal(el, 0);
          return;
        }
        // Door delivery leads; depot-collect options are offered as the alternative.
        var isCollect = function (r) { return /collect|pick ?up/i.test(r.n); };
        var door = rates.filter(function (r) { return !isCollect(r); });
        var best = door[0] || rates[0];
        var others = rates.filter(function (r) { return r !== best; }).slice(0, 2);
        var orderIn = el.box.hasAttribute('data-order-in');
        var when = range(best.d);
        if (mine) {
          el.price.textContent = money(best.p);
          el.line.innerHTML = (isCollect(best) ? best.n + '. ' : '') +
            (when ? '<strong>Arrives ' + when + '.</strong> ' : '') +
            (others.length ? 'Or ' + others.map(function (r) { return r.n.charAt(0).toLowerCase() + r.n.slice(1) + ' ' + money(r.p); }).join(' &middot; ') + ', at checkout. ' : '') +
            (orderIn ? 'Direct-ship gear travels separately, usually 2&ndash;7 business days.' : '');
          setTotal(el, best.p, pc);
        } else {
          // A labelled example until the shopper gives their own postcode:
          // never presented as their quote.
          el.price.innerHTML = '';
          if (el.to) el.to.textContent = '';
          el.line.innerHTML = '<span class="cx-ship__eg">e.g. Melbourne ' + pc + ':</span> from <strong>' + money(best.p).replace(/\.00$/, '') + '</strong>' + (when ? ', arrives ' + when : '') + '. Enter yours for your price.';
          setTotal(el, 0);
        }
      }).catch(function () {
        if (seq !== shipSeq) return;
        el.box.classList.remove('is-loading');
        if (mine) fallback(el, pc, st);
        else el.line.innerHTML = 'The carrier prices this exact cart live. Pop your postcode in.';
      });
    }
    function bindEta() {
      var el = shipEls();
      if (!el.box) return;
      var saved = '';
      try { saved = localStorage.getItem(PC_KEY) || ''; } catch (e) {}
      if (saved && pcState(saved)) { if (el.input) el.input.value = saved; shipRender(saved, true); }
      else shipRender(EXAMPLE_PC, false);
    }
    cart.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-cx-eta-form]')) return;
      e.preventDefault();
      var input = e.target.querySelector('[data-cx-eta-pc]');
      var pc = (input.value || '').replace(/\D/g, '').slice(0, 4);
      input.value = pc;
      shipRender(pc, true);
      if (pcState(pc)) { try { localStorage.setItem(PC_KEY, pc); } catch (err) {} }
    });
    cart.addEventListener('input', function (e) {
      if (!e.target.matches('[data-cx-eta-pc]')) return;
      var v = e.target.value.replace(/\D/g, '').slice(0, 4);
      if (v !== e.target.value) e.target.value = v;
      if (v.length === 4 && pcState(v)) { shipRender(v, true); try { localStorage.setItem(PC_KEY, v); } catch (err) {} }
    });

    /* ---- Promo code: applied in place via /cart/update.js ------------- */
    function currentCodes() {
      return Array.prototype.map.call(cart.querySelectorAll('[data-cx-promo-rm]'), function (b) { return b.getAttribute('data-cx-promo-rm'); });
    }
    function promo(codes, tried) {
      cart.classList.add('is-busy');
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), sections: [sectionId], sections_url: window.location.pathname })
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          cart.classList.remove('is-busy');
          var html = j.sections && j.sections[sectionId];
          if (!html) { window.location.reload(); return; }
          swap(html);
          var d = cart.querySelector('.cx-promo');
          if (d) d.open = true;
          var m = cart.querySelector('[data-cx-promo-msg]');
          if (tried && m) {
            var hit = (j.discount_codes || []).filter(function (c) { return String(c.code).toLowerCase() === tried.toLowerCase(); })[0];
            if (!hit || !hit.applicable) {
              m.textContent = tried.toUpperCase() + ' isn’t a valid code for what’s in this cart. Check the spelling, or try it again at checkout.';
              // don't leave a dud code sitting on the cart
              fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codes.filter(function (c) { return c !== tried; }).join(',') }) }).catch(function () {});
            }
          }
          var inp = cart.querySelector('[data-cx-promo-input]');
          if (inp && !tried) inp.focus();
        })
        .catch(function () {
          cart.classList.remove('is-busy');
          var m = cart.querySelector('[data-cx-promo-msg]');
          if (m) m.textContent = 'Couldn’t apply that just now. You can enter it at checkout too.';
        });
    }
    cart.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-cx-promo]')) return;
      e.preventDefault();
      var input = e.target.querySelector('[data-cx-promo-input]');
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      var codes = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      codes.push(code);
      promo(codes, code);
    });
    cart.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cx-promo-rm]');
      if (!rm) return;
      var code = rm.getAttribute('data-cx-promo-rm');
      promo(currentCodes().filter(function (c) { return c !== code; }), null);
    });

    bindBar();
    bindEta();
    markWallets();
    initRails(cart);
    if ('requestIdleCallback' in window) requestIdleCallback(loadRecs, { timeout: 1500 }); else setTimeout(loadRecs, 400);
  }

  /* ==================================================================== */
  /* SEARCH                                                                 */
  /* ==================================================================== */
  function initSearch() {
    var host = doc.querySelector('[data-cx-search]');
    if (!host) return;
    var sectionId = host.getAttribute('data-section');
    var ctrl = null;
    var lastFocus = null;

    function drawer(open) {
      var f = host.querySelector('[data-cx-filters]');
      var scrim = host.querySelector('.cx-scrim');
      var btn = host.querySelector('[data-cx-open-filters]');
      if (!f) return;
      f.classList.toggle('is-open', open);
      if (scrim) scrim.hidden = !open;
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      doc.documentElement.classList.toggle('aaa-no-scroll', open);
      doc.documentElement.classList.toggle('cx-drawer-open', open);
      if (open) {
        lastFocus = doc.activeElement;
        f.setAttribute('role', 'dialog');
        f.setAttribute('aria-modal', 'true');
        var c = f.querySelector('[data-cx-close-filters]');
        if (c) c.focus();
      } else {
        f.removeAttribute('role');
        f.removeAttribute('aria-modal');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
    }
    var mobile = window.matchMedia('(max-width: 989px)');

    /* Cooker style / fuel facet counts: one tiny section render per option,
       cached, run when the browser is idle. Options with nothing are hidden. */
    var counts = {};
    function fillCounts() {
      var links = host.querySelectorAll('[data-cx-count-q]');
      if (!links.length) return;
      var run = function () {
        Array.prototype.forEach.call(links, function (a) {
          var q = a.getAttribute('data-cx-count-q');
          var put = function (n) {
            var el = a.querySelector('[data-cx-n]');
            if (el) el.textContent = n;
            var li = a.closest('[data-cx-type]');
            if (li) li.hidden = n === 0;
          };
          if (q in counts) { put(counts[q]); return; }
          fetch('/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=aaa-cart-count')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (h) {
              var m = /data-cx-count="(\d+)"/.exec(h);
              if (!m) return;
              counts[q] = parseInt(m[1], 10);
              put(counts[q]);
            })
            .catch(function () {});
        });
      };
      if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 1500 }); else setTimeout(run, 300);
    }

    /* The header search box shows what the shopper typed, not the facet syntax. */
    function syncHeaderBox() {
      var full = host.getAttribute('data-cx-q') || '';
      var base = host.getAttribute('data-cx-base') || '';
      if (full === base) return;
      Array.prototype.forEach.call(doc.querySelectorAll('input[name="q"]'), function (i) {
        if (host.contains(i)) return;
        if (i.value === full) i.value = base;
      });
    }

    /* Range chips: edge fade + next arrow while there is more to scroll. */
    function initScroller() {
      var sc = host.querySelector('[data-cx-scroller]');
      if (!sc) return;
      var ul = sc.querySelector('ul');
      var sync = function () {
        var more = ul.scrollWidth - ul.clientWidth - ul.scrollLeft > 4;
        sc.classList.toggle('has-more', more);
        sc.classList.toggle('has-less', ul.scrollLeft > 4);
      };
      ul.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      var nx = sc.querySelector('[data-cx-scroll-next]');
      if (nx) nx.addEventListener('click', function () { ul.scrollBy({ left: ul.clientWidth * 0.7, behavior: reduce ? 'auto' : 'smooth' }); });
      sync();
    }
    /* Long facets (brand): top six by count, "Show all N", and a find box. */
    function initFacets() {
      Array.prototype.forEach.call(host.querySelectorAll('[data-cx-fg-list].is-collapsible'), function (ul) {
        var fg = ul.closest('.cx-fg');
        var btn = fg.querySelector('[data-cx-fg-toggle]');
        var find = fg.querySelector('[data-cx-find-wrap]');
        var extras = ul.querySelectorAll('.cx-fg__extra:not(.cx-fg__zero)');
        if (!extras.length) { ul.classList.remove('is-collapsed'); return; }
        if (btn) {
          btn.hidden = false;
          var set = function (open) {
            ul.classList.toggle('is-collapsed', !open);
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            btn.querySelector('[data-cx-more-label]').hidden = open;
            btn.querySelector('[data-cx-less-label]').hidden = !open;
          };
          if (ul.__cxOpen) set(true);
          btn.addEventListener('click', function () {
            var open = ul.classList.contains('is-collapsed');
            ul.__cxOpen = open;
            set(open);
            facetOpen[fg.querySelector('summary').textContent.trim()] = open;
            if (open && find) { var i = find.querySelector('input'); if (i) i.focus({ preventScroll: true }); }
          });
          if (facetOpen[fg.querySelector('summary').textContent.trim()]) set(true);
        }
        if (find) {
          var input = find.querySelector('[data-cx-find]');
          var none = doc.createElement('p'); none.className = 'cx-fg__none'; none.hidden = true; ul.after(none);
          input.addEventListener('input', function () {
            var q = input.value.trim().toLowerCase();
            var hits = 0;
            ul.classList.toggle('is-filtering', q !== '');
            Array.prototype.forEach.call(ul.children, function (li) {
              if (li.classList.contains('cx-fg__zero')) return;
              var t = (li.querySelector('.cx-check__label') || li).textContent.toLowerCase();
              var miss = q !== '' && t.indexOf(q) === -1;
              li.classList.toggle('is-miss', miss);
              if (!miss) hits++;
            });
            none.hidden = hits > 0;
            none.textContent = 'Nothing matching \u201c' + input.value.trim() + '\u201d here.';
          });
        }
      });
    }
    var facetOpen = {};

    /* ---- Compare: tick up to three cookers, tray at the bottom, side-by-side
       table built from each product's own spec sheet. ----------------------- */
    var CMP_KEY = 'cx-compare';
    var CMP_MAX = 3;
    function cmpGet() { try { return JSON.parse(sessionStorage.getItem(CMP_KEY)) || []; } catch (e) { return []; } }
    function cmpSet(list) { try { sessionStorage.setItem(CMP_KEY, JSON.stringify(list)); } catch (e) {} }
    function esc(t) { var d = doc.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
    function cmpSync() {
      var list = cmpGet();
      var handles = list.map(function (x) { return x.h; });
      Array.prototype.forEach.call(host.querySelectorAll('[data-cx-cmp]'), function (cb) {
        cb.checked = handles.indexOf(cb.value) !== -1;
        cb.disabled = !cb.checked && list.length >= CMP_MAX;
      });
      host.classList.toggle('cx-cmp-on', list.length > 0);
      var fillN = host.querySelector('[data-cx-fill-n]');
      if (fillN) fillN.textContent = list.length;
      var fillBtn = host.querySelector('[data-cx-fill-cmp]');
      if (fillBtn) fillBtn.classList.toggle('is-ready', list.length >= 2);
      var fillHint = host.querySelector('[data-cx-fill-hint]');
      if (fillHint && list.length >= 2) fillHint.textContent = '';
      var tray = host.querySelector('[data-cx-tray]');
      if (!tray) return;
      var slots = tray.querySelector('[data-cx-tray-slots]');
      var html = list.map(function (x) {
        return '<li class="cx-tray__slot">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" width="48" height="48" loading="lazy">' : '') +
          '<span>' + esc(x.t) + '</span><button type="button" class="cx-tray__x" data-cx-cmp-remove="' + esc(x.h) + '" aria-label="Remove ' + esc(x.t) + ' from compare">' +
          '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="m4 4 8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></li>';
      }).join('');
      for (var i = list.length; i < CMP_MAX; i++) html += '<li class="cx-tray__slot is-empty">' + (i === list.length ? 'Tick another cooker' : 'Empty slot') + '</li>';
      slots.innerHTML = html;
      tray.querySelector('[data-cx-tray-count]').textContent = list.length;
      tray.querySelector('[data-cx-tray-hint]').textContent = list.length === 1 ? 'cooker picked. Add one more to compare' : 'of ' + CMP_MAX + ' picked to compare';
      var go = tray.querySelector('[data-cx-cmp-open]');
      go.disabled = list.length < 2;
      go.textContent = list.length >= 2 ? 'Compare ' + list.length : 'Compare';
      var on = list.length > 0;
      if (on) tray.hidden = false;
      window.requestAnimationFrame(function () { tray.classList.toggle('is-on', on); });
      host.classList.toggle('has-tray', on);
      if (!on) setTimeout(function () { if (!cmpGet().length) tray.hidden = true; }, 400);
    }
    var cmpCache = {};
    function cmpOpen() {
      var dlg = host.querySelector('[data-cx-cmp-dialog]');
      var body = dlg && dlg.querySelector('[data-cx-cmp-body]');
      if (!dlg || !body) return;
      var list = cmpGet();
      if (list.length < 2) return;
      lastFocus = doc.activeElement;
      body.innerHTML = '<p class="cx-cmp__load">Pulling the spec sheets\u2026</p>';
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      doc.documentElement.classList.add('aaa-no-scroll');
      Promise.all(list.map(function (x) {
        if (cmpCache[x.h]) return Promise.resolve(cmpCache[x.h]);
        return fetch(root + 'products/' + encodeURIComponent(x.h) + '?section_id=aaa-cart-compare')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h) { var col = parse(h).querySelector('[data-cx-cmpcol]'); if (col) cmpCache[x.h] = col; return col; })
          .catch(function () { return null; });
      })).then(function (cols) {
        cols = cols.filter(Boolean);
        if (cols.length < 2) { body.innerHTML = '<p class="cx-cmp__load">Couldn\u2019t load those spec sheets. Open each product instead.</p>'; return; }
        var order = []; var labels = {}; var vals = cols.map(function () { return {}; });
        cols.forEach(function (col, ci) {
          Array.prototype.forEach.call(col.querySelectorAll('.cx-cmpcol__rows > [data-k]'), function (row) {
            var k = row.getAttribute('data-k');
            if (!(k in labels)) { labels[k] = row.querySelector('dt').textContent.trim(); order.push(k); }
            vals[ci][k] = row.querySelector('dd').innerHTML.trim();
          });
        });
        var count = function (k) { return vals.filter(function (v) { return k in v; }).length; };
        var shared = order.filter(function (k) { return k.charAt(0) !== '_' && (count(k) === cols.length || k === 'reviews'); });
        var partial = order.filter(function (k) { return k.charAt(0) !== '_' && shared.indexOf(k) === -1 && count(k) >= 2; });
        var single = order.filter(function (k) { return k.charAt(0) !== '_' && shared.indexOf(k) === -1 && partial.indexOf(k) === -1; });
        var row = function (k) {
          var cells = vals.map(function (v) { return v[k]; });
          var plain = cells.map(function (c) { return (c || '').replace(/<[^>]+>/g, '').trim().toLowerCase(); });
          var diff = plain.some(function (c) { return c !== plain[0]; });
          return '<tr' + (diff ? ' class="is-diff"' : '') + '><th scope="row">' + esc(labels[k]) + '</th>' +
            cells.map(function (c) { return '<td>' + (c ? c : '<span class="cx-cmpt__none">Not listed</span>') + '</td>'; }).join('') + '</tr>';
        };
        var sep = function (t) { return '<tr class="cx-cmpt__sep"><th colspan="' + (cols.length + 1) + '" scope="colgroup">' + t + '</th></tr>'; };
        var html = '<table class="cx-cmpt" style="--cols:' + cols.length + '"><colgroup><col class="cx-cmpt__k">' + cols.map(function () { return '<col>'; }).join('') + '</colgroup>' +
          '<thead><tr><th scope="col"><span class="aaa-vh">Spec</span></th>' + cols.map(function (c) { return '<td>' + c.querySelector('[data-k="_head"]').innerHTML + '</td>'; }).join('') + '</tr></thead><tbody>';
        html += shared.concat(partial).map(row).join('');
        if ('_features' in labels) html += sep('Key features') + row('_features').replace('<th scope="row">Key features</th>', '<th scope="row">From the maker</th>');
        if (single.length) html += sep('Only listed for one') + single.map(row).join('');
        html += '</tbody></table>';
        body.innerHTML = html;
        var close = dlg.querySelector('[data-cx-cmp-close]'); if (close) close.focus();
      });
    }
    function cmpClose() {
      var dlg = host.querySelector('[data-cx-cmp-dialog]');
      if (!dlg) return;
      if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
    }
    function cmpBind() {
      var dlg = host.querySelector('[data-cx-cmp-dialog]');
      if (!dlg || dlg.__cx) return;
      dlg.__cx = true;
      dlg.addEventListener('close', function () {
        doc.documentElement.classList.remove('aaa-no-scroll');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) cmpClose();
        if (e.target.closest('[data-cx-cmp-close]')) cmpClose();
      });
    }

    function refresh() { fillCounts(); initScroller(); initFacets(); cmpBind(); cmpSync(); if (typeof pinRail === 'function') { pinRail(); if (roRail) { roRail.disconnect(); var fr2 = host.querySelector('[data-cx-filters]'); if (fr2) roRail.observe(fr2); } } }

    function urlFromForm(form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) {
        if (typeof v === 'string' && v.trim() === '') return;
        params.append(k, v);
      });
      return form.getAttribute('action') + '?' + params.toString();
    }

    function load(url, opts) {
      opts = opts || {};
      var results = host.querySelector('[data-cx-results]');
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      if (results) results.classList.add('is-loading');
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return fetch(url + sep + 'section_id=' + sectionId, { signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = parse(html).querySelector('[data-cx-search]');
          if (!fresh) { window.location.href = url; return; }
          var wasOpen = host.querySelector('[data-cx-filters].is-open');
          // keep open/closed state of filter groups
          var openState = {};
          Array.prototype.forEach.call(host.querySelectorAll('.cx-fg'), function (d, i) { openState[i] = d.open; });
          var scrollY = window.scrollY;
          host.innerHTML = fresh.innerHTML;
          host.setAttribute('data-cx-q', fresh.getAttribute('data-cx-q') || '');
          host.setAttribute('data-cx-base', fresh.getAttribute('data-cx-base') || '');
          refresh(); syncHeaderBox();
          Array.prototype.forEach.call(host.querySelectorAll('.cx-fg'), function (d, i) { if (i in openState) d.open = openState[i]; });
          if (wasOpen && mobile.matches) {
            var f = host.querySelector('[data-cx-filters]');
            f.classList.add('is-open');
            f.setAttribute('role', 'dialog');
            f.setAttribute('aria-modal', 'true');
            var s = host.querySelector('.cx-scrim'); if (s) s.hidden = false;
            if (opts.focusName) {
              var el = f.querySelector('[name="' + opts.focusName + '"][value="' + (opts.focusValue || '').replace(/"/g, '\\"') + '"]') || f.querySelector('[name="' + opts.focusName + '"]');
              if (el) el.focus({ preventScroll: true });
            }
          } else {
            doc.documentElement.classList.remove('aaa-no-scroll');
            doc.documentElement.classList.remove('cx-drawer-open');
            if (opts.focusName) {
              var el2 = host.querySelector('[data-cx-filters] [name="' + opts.focusName + '"][value="' + (opts.focusValue || '').replace(/"/g, '\\"') + '"]') || host.querySelector('[data-cx-filters] [name="' + opts.focusName + '"]');
              if (el2) el2.focus({ preventScroll: true });
            }
            var tb = host.querySelector('[data-cx-tb]');
            if (tb && opts.scrollTop) {
              var top = tb.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(doc.documentElement).getPropertyValue('--aaa-header-h'), 10) || 0);
              if (scrollY > top) window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
            }
          }
          if (opts.push !== false) history.pushState({ cx: 1 }, '', url);
        })
        .catch(function (e) { if (!e || e.name !== 'AbortError') window.location.href = url; });
    }

    var debounce;
    host.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-cx-find]')) return;
      if (t.matches('[data-cx-cmp]')) {
        var list = cmpGet().filter(function (x) { return x.h !== t.value; });
        if (t.checked && list.length < CMP_MAX) list.push({ h: t.value, t: t.getAttribute('data-title'), img: t.getAttribute('data-img') });
        cmpSet(list); cmpSync();
        return;
      }
      var form = t.closest('[data-cx-filter-form]');
      if (form) {
        if (t.matches('[data-cx-price]')) return; // handled on blur / enter via submit
        clearTimeout(debounce);
        debounce = setTimeout(function () { load(urlFromForm(form), { focusName: t.name, focusValue: t.value, scrollTop: true }); }, 120);
        return;
      }
      if (t.matches('[data-cx-sort-select]')) load(urlFromForm(t.form), { focusName: null, scrollTop: true });
    });
    host.addEventListener('focusout', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-cx-price]')) return;
      if (t.value === t.defaultValue) return;
      var form = t.closest('[data-cx-filter-form]');
      load(urlFromForm(form), { focusName: null, scrollTop: true });
    });
    host.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.matches('[data-cx-filter-form]')) {
        e.preventDefault();
        if (mobile.matches && host.querySelector('[data-cx-filters].is-open') && e.submitter && e.submitter.matches('[data-cx-apply]')) { drawer(false); return; }
        load(urlFromForm(form), { scrollTop: true });
      } else if (form.matches('[data-cx-sort]')) {
        e.preventDefault();
        load(urlFromForm(form), { scrollTop: true });
      }
    });

    host.addEventListener('click', function (e) {
      if (e.target.closest('[data-cx-open-filters]')) { drawer(true); return; }
      var rm = e.target.closest('[data-cx-cmp-remove]');
      if (rm) { var h = rm.getAttribute('data-cx-cmp-remove'); cmpSet(cmpGet().filter(function (x) { return x.h !== h; })); cmpSync(); return; }
      if (e.target.closest('[data-cx-cmp-clear]')) { cmpSet([]); cmpSync(); return; }
      if (e.target.closest('[data-cx-cmp-open]')) { cmpOpen(); return; }
      if (e.target.closest('[data-cx-fill-cmp]')) {
        var picked = cmpGet().length;
        if (picked >= 2) { cmpOpen(); return; }
        // Not enough picked yet: point at the Compare ticks rather than open an empty table.
        var hint = host.querySelector('[data-cx-fill-hint]');
        if (hint) hint.textContent = picked === 1 ? 'One picked. Tick Compare on one more cooker.' : 'Tick Compare on two or three cookers, then come back here.';
        var firstBox = host.querySelector('[data-cx-grid] .cx-pc__cmp');
        host.classList.remove('cx-cmp-nudge'); void host.offsetWidth; host.classList.add('cx-cmp-nudge');
        setTimeout(function () { host.classList.remove('cx-cmp-nudge'); }, 2600);
        if (firstBox && firstBox.getBoundingClientRect().top < 0) firstBox.closest('.cx-grid__item').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      if (e.target.closest('[data-cx-close-filters]')) { drawer(false); return; }
      var link = e.target.closest('[data-cx-link]');
      if (link && !e.metaKey && !e.ctrlKey) { e.preventDefault(); load(link.getAttribute('href'), { scrollTop: true }); return; }
      var more = e.target.closest('[data-cx-more]');
      if (more && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        if (more.classList.contains('is-busy')) return;
        more.classList.add('is-busy');
        var href = more.getAttribute('href');
        fetch(href + (href.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var d = parse(html);
            var items = d.querySelectorAll('[data-cx-grid] > li');
            var grid = host.querySelector('[data-cx-grid]');
            var accGrid = host.querySelector('[data-cx-grid-acc]');
            var accItems = d.querySelectorAll('[data-cx-grid-acc] > li');
            var firstNew = null;
            // The last-row fill tile only makes sense at the end of page one.
            var fillOld = grid.querySelector('[data-cx-fill]'); if (fillOld) fillOld.remove();
            Array.prototype.forEach.call(items, function (li, i) {
              if (li.hasAttribute('data-cx-fill')) return;
              li.classList.add('is-new');
              li.style.animationDelay = Math.min(i, 8) * 30 + 'ms';
              grid.appendChild(li);
              if (!firstNew) firstNew = li;
            });
            if (accGrid) {
              Array.prototype.forEach.call(accItems, function (li, i) {
                li.classList.add('is-new');
                li.style.animationDelay = Math.min(i, 8) * 30 + 'ms';
                accGrid.appendChild(li);
                if (!firstNew) firstNew = li;
              });
              var accSec = host.querySelector('[data-cx-accs]');
              if (accSec && accGrid.children.length >= 3) accSec.hidden = false;
            }
            // Guides and pages that matched on the next page join the guides strip
            // (de-duplicated by link), so the guide count stays true to the page.
            var newPages = d.querySelector('.cx-pages');
            if (newPages) {
              var list = host.querySelector('.cx-pages__list');
              if (!list) {
                var navNow = host.querySelector('[data-cx-more-wrap]');
                if (navNow) { navNow.before(newPages); list = newPages.querySelector('.cx-pages__list'); }
              } else {
                Array.prototype.forEach.call(newPages.querySelectorAll('.cx-pages__list > li'), function (li) {
                  var a0 = li.querySelector('a');
                  var href = a0 ? a0.getAttribute('href') : '';
                  if (href && list.querySelector('a[href="' + href.replace(/"/g, '\\"') + '"]')) return;
                  li.classList.add('is-new'); list.appendChild(li);
                });
                list.style.setProperty('--n', Math.min(3, list.children.length));
              }
            }
            cmpSync();
            var newNav = d.querySelector('[data-cx-more-wrap]');
            var nav = host.querySelector('[data-cx-more-wrap]');
            var nextLink = newNav && newNav.querySelector('[data-cx-more]');
            // Counts come from the server's own tally of each page (products and
            // guides alike), so the toolbar and progress always agree.
            var total = nav ? parseInt(nav.getAttribute('data-cx-total'), 10) : 0;
            var addShown = newNav ? parseInt(newNav.getAttribute('data-cx-shown'), 10) || 0 : 0;
            var seenNow = nav ? (parseInt((nav.querySelector('[data-cx-seen]') || {}).textContent, 10) || 0) : 0;
            var seen = Math.min(total, seenNow + addShown);
            // Toolbar tally: add the next page's own cookers / add-ons / guides.
            var tbNew = d.querySelector('.cx-tb__count');
            Array.prototype.forEach.call(host.querySelectorAll('.cx-tb__count [data-cx-k]'), function (k) {
              var src = tbNew && tbNew.querySelector('[data-cx-k="' + k.getAttribute('data-cx-k') + '"] b');
              var add = src ? parseInt(src.textContent, 10) || 0 : 0;
              var b = k.querySelector('b');
              var n = (parseInt(b.textContent, 10) || 0) + add;
              b.textContent = n;
              k.querySelector('i').textContent = n === 1 ? k.getAttribute('data-one') : k.getAttribute('data-many');
              k.hidden = n === 0;
            });
            if (nav) {
              var seenEl = nav.querySelector('[data-cx-seen]'); if (seenEl) seenEl.textContent = seen;
              if (!nextLink) { var cnt = nav.querySelector('.cx-more__count'); if (cnt) cnt.textContent = 'That’s every match for “' + (host.getAttribute('data-cx-base') || '') + '”'; }
              var fill = nav.querySelector('[data-cx-bar-fill]'); if (fill) fill.style.width = Math.min(100, Math.round(seen / total * 100)) + '%';
              var prev = nav.querySelector('.cx-more__ctl a:not([data-cx-more])'); if (prev) prev.remove();
              if (nextLink) { more.setAttribute('href', nextLink.getAttribute('href')); more.textContent = nextLink.textContent; more.classList.remove('is-busy'); }
              else more.remove();
            }
            var a = firstNew && firstNew.querySelector('a[href]:not([tabindex="-1"])');
            if (a) a.focus({ preventScroll: true });
          })
          .catch(function () { window.location.href = href; });
      }
    });

    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && host.querySelector('[data-cx-filters].is-open')) drawer(false);
    });
    // Toolbar: a soft shadow once it pins under the header, so it reads as a
    // bar that travels with you rather than a line in the page.
    var stuckTick = false;
    var stuck = function () {
      stuckTick = false;
      var tb = host.querySelector('[data-cx-tb]');
      if (!tb) return;
      var top = parseInt(getComputedStyle(tb).top, 10) || 0;
      tb.classList.toggle('is-stuck', tb.getBoundingClientRect().top <= top + 1 && window.scrollY > 40);
    };
    window.addEventListener('scroll', function () { if (!stuckTick) { stuckTick = true; window.requestAnimationFrame(stuck); } }, { passive: true });
    // Filter rail pin: by its top when it fits in the window, else by its
    // bottom, so a long rail never gets clipped.
    var roRail = null;
    var pinRail = function () {
      var f = host.querySelector('[data-cx-filters]');
      if (!f) return;
      if (mobile.matches) { f.classList.remove('is-pin-top', 'is-pin-bottom'); return; }
      var tb = host.querySelector('[data-cx-tb]');
      var room = window.innerHeight - (parseInt(getComputedStyle(doc.documentElement).getPropertyValue('--aaa-header-h'), 10) || 0) - (tb ? tb.offsetHeight : 0) - 16;
      var fits = f.scrollHeight <= room;
      f.classList.toggle('is-pin-top', fits);
      f.classList.toggle('is-pin-bottom', !fits);
    };
    host.addEventListener('toggle', pinRail, true);
    window.addEventListener('resize', pinRail);
    if (window.ResizeObserver) { roRail = new ResizeObserver(function () { pinRail(); }); var fr = host.querySelector('[data-cx-filters]'); if (fr) roRail.observe(fr); }
    refresh(); syncHeaderBox(); stuck(); pinRail();
    window.addEventListener('popstate', function () { load(window.location.pathname + window.location.search, { push: false }); });
  }

  function boot() { initRails(); initCart(); initSearch(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
